import { Toasts } from '@fourthwall/components'

import { useDnsQuery } from '../../../../../../../hooks/useDnsQuery'
import { useCreateDomainMutation } from '../../../queries/useCreateDomainMutation'
import { useGetPaidDomainsQuery } from '../queries/useGetPaidDomainsQuery'
import {
  type RegisterPaidDomainRequestBody,
  useRegisterPaidDomainMutation,
} from '../queries/useRegisterPaidDomainMutation'
import { splitDomain } from '../utils/splitDomain'

type TldType = RegisterPaidDomainRequestBody['tld']

export const usePaidDomain = () => {
  const { getPaidDomainsQuery, invalidateGetPaidDomainsQuery } = useGetPaidDomainsQuery()
  const { registerPaidDomainMutation } = useRegisterPaidDomainMutation()
  const { createDomainMutation } = useCreateDomainMutation()
  const { invalidateDnsQuery } = useDnsQuery([], {})

  const registerDomain = async (domain: string) => {
    const { mainDomain, tld } = splitDomain(domain)

    await registerPaidDomainMutation.mutateAsync([{ name: mainDomain, tld: tld as TldType }])

    createDomainMutation.mutate(
      {
        domain,
      },
      {
        onSuccess: () => {
          Toasts.notify(
            "We're pulling information about the domain. This can take up to 30 seconds.",
            {
              type: 'info',
              autoClose: false,
            },
          )
        },
      },
    )

    invalidateGetPaidDomainsQuery()
    invalidateDnsQuery()
  }

  return {
    currentDomain: getPaidDomainsQuery.data?.[0] || null,
    isLoading: getPaidDomainsQuery.isLoading,
    isRegistering: registerPaidDomainMutation.isLoading,
    registerDomain,
  }
}
